import { Dialog } from "construct-ui";
import moment from "moment";
import FileUploadInputComponent from "../../../components/file/file-upload-input.component";
import paginationComponent from "../../../components/pagination/pagination.component";
import SingleSelectComponent from "../../../components/single-select/single-select.component";
import { formats } from "../../../config/constants";
import EdiManagementSiteMappingModel from "../../../models/reports/edi-management-site-mapping.model";
import ViewBase from "../../view-base.view";

export default function EdiManagementSiteMappingView() {
  ViewBase.call(this);

  let customers = [];
  let selectedCustomer;

  let interfaceChannelAttr1 = "";
  let interfaceChannelAttr2 = "";
  let samsungChannel = "";

  const pagination = {
    pageIndex: 1,
    pageSize: 10,
    totalItems: 0,
  };

  let searchResult;

  let selectedCustomerAddNew;
  let interfaceChannelAttr1AddNew = "";
  let interfaceChannelAttr2AddNew = "";
  let samsungChannelAddNew = "";

  let editedInterfaceChannelAttr2 = "";
  let editedSamsungChannel;

  let tempEditItem;

  let isAddSiteMappingOpen = false;
  let isEditSiteMappingOpen = false;
  let isExcelUploadModalOpen = false;

  let fileInput;

  const handleChangeInterfaceChannelAttr1 = (e) => {
    interfaceChannelAttr1 = e.target.value;
  };

  const handleChangeIfChannelAttr2 = (e) => {
    interfaceChannelAttr2 = e.target.value;
  };

  const handleChangeSamsungChannel = (e) => {
    samsungChannel = e.target.value;
  };

  const handleSelectCustomer = (customer) => {
    selectedCustomer = customer;
  };

  const handleSelectCustomerAddNew = (customer) => {
    selectedCustomerAddNew = customer;
  };

  const handleChangeInterfaceChannelAttr1AddNew = (e) => {
    interfaceChannelAttr1AddNew = e.target.value.trimStart();
  };

  const handleChangeInterfaceChannelAttr2AddNew = (e) => {
    interfaceChannelAttr2AddNew = e.target.value.trimStart();
  };

  const handleChangeSamsungChannelAddNew = (e) => {
    samsungChannelAddNew = e.target.value.trimStart();
  };

  const handleChangeInterfaceChannelAttr2Edit = (e) => {
    editedInterfaceChannelAttr2 = e.target.value.trimStart();
  }

  const handleChangeSamsungChannelEdit = (e) => {
    editedSamsungChannel = e.target.value.trimStart();
  }

  const handleClearFilter = () => {
    selectedCustomer = null;
    interfaceChannelAttr1 = "";
    interfaceChannelAttr2 = "";
    samsungChannel = "";
  };

  const handlePageChanged = (page) => {
    pagination.pageIndex = page;
    fetchData();
  };

  const handlePageSizeChanged = (page, size) => {
    pagination.pageIndex = page;
    pagination.pageSize = size;
    fetchData();
  };

  const handleCloseAddNewSiteMappingModal = () => {
    isAddSiteMappingOpen = false;

    interfaceChannelAttr1AddNew = "";
    interfaceChannelAttr2AddNew = "";
    samsungChannelAddNew = "";
    selectedCustomerAddNew = undefined;
  };

  const handleCloseEditSiteMappingModal = () => {
    isEditSiteMappingOpen = false;
    editedSamsungChannel = "";
    editedInterfaceChannelAttr2 = "";
    tempEditItem = undefined;
  };

  const handleClickDownloadResult = () => {
    if (!searchResult) {
      return;
    }

    this.showLoading();
    const config = {
      customerCode: selectedCustomer?.code,
      mapAttribute1: samsungChannel,
      mapAttribute2: interfaceChannelAttr2,
      mapType: "CHANNEL_MAP",
      mapKey: interfaceChannelAttr1,
      pageIndex: -1,
    };

    EdiManagementSiteMappingModel.downloadSearchResultToExcel(config)
      .catch((err) => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading();
      });
  };

  const handleClickSearch = () => {
    pagination.pageIndex = 1;
    fetchData();
  };

  const handleClickSaveEdit = () => {

    this.showLoading();

    let editedItem = {
      customerCode: tempEditItem.customerCode,
      mapType: "CHANNEL_MAP",
      mapKey: tempEditItem.mapKey,
      mapAttribute1: editedSamsungChannel.trimEnd(),
      mapAttribute2: editedInterfaceChannelAttr2.trimEnd(),
    }

    EdiManagementSiteMappingModel.update(editedItem)
      .then(() => {
        const onCloseMessage = () => {
          isEditSiteMappingOpen = false;
          tempEditItem = undefined;
          editedSamsungChannel = "";
          editedInterfaceChannelAttr2 = "";
          fetchData();
        };

        this.showMessage(
          this.getText("LT00001016", "Item edited successfully"),
          null,
          onCloseMessage
        );
      })
      .catch((err) => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading();
      });

  };

  const handleClickDelete = (item) => {
    const handleConfirm = (action) => {
      if (action === "YES") {
        this.showLoading();

        let deleteItem = {
          customerCode: item.customerCode,
          mapType: item.mapType,
          mapKey: item.mapKey,
          mapAttribute1: item.mapAttribute1,
          mapAttribute2: item.mapAttribute2,
        };

        EdiManagementSiteMappingModel.delete(deleteItem)
          .then(() => {
            const onCloseMessage = () => {
              pagination.pageIndex = 1;
              fetchData();
            };

            this.showMessage(
              this.getText("LT00001077", "Item deleted successfully"),
              null,
              onCloseMessage
            );
          })
          .catch((err) => {
            this.handleError(err);
          })
          .finally(() => {
            this.hideLoading();
          });
      }
    };

    this.showConfirm(
      this.getText("EM00000265", "Are you sure you want to delete?"),
      null,
      handleConfirm
    );
  };

  const handleClickEdit = (item) => {
    tempEditItem = item;
    editedInterfaceChannelAttr2 = item.mapAttribute2;
    editedSamsungChannel = item.mapAttribute1;
    isEditSiteMappingOpen = true;
  };

  const handleClickAdd = () => {
    isAddSiteMappingOpen = true;
  };

  const handleSubmitAddNew = (e) => {

    e.preventDefault();
    e.target.classList.add("was-validated");

    if (!e.target.checkValidity()) {
      e.stopPropagation();
      return;
    }

    this.showLoading();

    let newItem = {
      customerCode: selectedCustomerAddNew.code,
      mapType: "CHANNEL_MAP",
      mapKey: interfaceChannelAttr1AddNew.trimEnd(),
      mapAttribute1: samsungChannelAddNew.trimEnd(),
      mapAttribute2: interfaceChannelAttr2AddNew.trimEnd(),
    };

    EdiManagementSiteMappingModel.add(newItem)
      .then(() => {
        const onCloseMessage = () => {
          isAddSiteMappingOpen = false;

          interfaceChannelAttr1AddNew = "";
          interfaceChannelAttr2AddNew = "";
          samsungChannelAddNew = "";
          selectedCustomerAddNew = undefined;

          fetchData();
        };

        this.showMessage(
          this.getText("LT00001018", "Item added successfully"),
          null,
          onCloseMessage
        );
      })
      .catch((err) => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  const openExcelUploadModal = () => {
    isExcelUploadModalOpen = true;
  };

  const closeExcelUploadModal = () => {
    isExcelUploadModalOpen = false;
    fileInput = null;
  };

  const handleUploadInputChange = (data) => {
    fileInput = data;
  };

  const downloadTemplate = () => {
    this.showLoading();
    EdiManagementSiteMappingModel.downloadTemplate()
      .catch((error) => { this.handleError(error); })
      .finally(() => { this.hideLoading(); });
  };


  const submitUploadTemplate = (e) => {
    e.preventDefault();
    uploadSiteMapping();
  };

  const uploadSiteMapping = () => {
    if (!fileInput) return;

    this.showLoading();
    const formData = new FormData();
    formData.append("uploadedExcel", fileInput);

    EdiManagementSiteMappingModel.uploadExcel(formData)
      .then(() => {
        this.showMessage(
          this.getText("LT00000914", "The file has been uploaded successfully"),
          this.getText("EM00000313", "Upload Completed"),
          () => {
            isExcelUploadModalOpen = false;
          }
        );
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  };

  const fetchData = () => {
    this.showLoading();

    let queries = {
      customerCode: selectedCustomer?.code,
      mapKey: interfaceChannelAttr1,
      mapAttribute1: samsungChannel,
      mapAttribute2: interfaceChannelAttr2,
      pageSize: pagination.pageSize,
      pageIndex: pagination.pageIndex,
    };

    EdiManagementSiteMappingModel.search(queries)
      .then((searchRes) => {
        searchResult = searchRes.data || [];
        pagination.totalItems = searchRes.total;
        pagination.pageIndex = searchRes.pageIndex;
        pagination.pageSize = searchRes.pageSize;
      })
      .catch((err) => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading();
      });
  };

  const fetchInitialData = () => {
    this.showLoading();

    EdiManagementSiteMappingModel.getCustomers()
      .then((customerRes) => {
        customers = customerRes;
      })
      .catch((err) => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading();
      });
  };


  return {
    oninit: () => {
      fetchInitialData();
    },

    view: () => {
      return [
        m(".d-md-flex.justify-content-end",
          m(".text-end",
            m("button.btn.btn-outline-primary.btn-add.mb-2",
              { onclick: handleClickAdd },
              m("i.bi.bi-plus-lg.me-0")
            )
          )
        ),

        m(".card.my-3",
          m(".card-body",
            m(".row.g-2",
              m(".col-md-6.col-lg-3",
                m("label.form-label",
                  this.getText("LT00008046", "Customer")
                ),
                m(SingleSelectComponent, {
                  items: customers,
                  selectedItem: selectedCustomer,
                  onSelect: handleSelectCustomer,
                })
              ),

              m(".col-md-6.col-lg-3",
                m("label.form-label", this.getText("LT00001081", "I/F Channel Attr 1")),
                m('input.form-control.form-control-bg[type="text"][maxLength="150"]', {
                  value: interfaceChannelAttr1,
                  onchange: handleChangeInterfaceChannelAttr1,
                })
              ),

              m(".col-md-6.col-lg-3",
                m("label.form-label", this.getText("LT00001082", "I/F Channel Attr 2")),
                m('input.form-control.form-control-bg[type="text"][maxLength="150"]', {
                  value: interfaceChannelAttr2,
                  onchange: handleChangeIfChannelAttr2,
                })

              ),
              m(".col-md-6.col-lg-3",
                m("label.form-label", this.getText("LT00001012", "Samsung Channel")),
                m('input.form-control.form-control-bg[type="text"][maxLength="20"]', {
                  value: samsungChannel,
                  onchange: handleChangeSamsungChannel,
                })
              ),
            ),

            m(".row.g-2.justify-content-end.mt-2.mt-md-3",
              m(".col-12.gap-2.d-flex.justify-content-end.flex-wrap",
                m("button.btn.btn-primary",
                  { onclick: handleClickSearch },
                  this.getText("LT00000001", "Search")
                ),

                m("button.btn.btn-white",
                  { onclick: handleClearFilter },
                  this.getText("LT00000031", "Clear")
                )
              )
            )
          )
        ),

        m(".card",
          m(".d-md-flex.justify-content-end",
            m(".mt-2.me-2.text-end",
              m("a.btn.btn-primary",
                {
                  onclick: openExcelUploadModal,
                },
                m("i.bi.bi-file-earmark-arrow-up-fill"),
                this.getText("LT00000197", "Excel Upload")
              )
            ),
            m(".mt-2.me-2.text-end",
              m("a.btn.btn-primary",
                {
                  class: !searchResult || searchResult.length === 0 ? "disabled" : "",
                  onclick: handleClickDownloadResult,
                },
                m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText("LT00000018", "Excel Download"),
              )
            ),
          ),

          m(".mt-2",
            m(".row.mx-0",
              m(".col-12.p-0",
                m(".table-responsive",
                  m("table.table",
                    m("thead.thead-bggrey",
                      m("tr.align-middle",
                        m("th[scope=col]", this.getText("LT00000576", "Subsidiary")),
                        m("th[scope=col]", this.getText("LT00008046", "Customer")),
                        m("th[scope=col]", this.getText("LT00001011", "Map Type")),
                        m("th[scope=col]", this.getText("LT00001008", "I/F Channel Attr 1")),
                        m("th[scope=col]", this.getText("LT00001009", "I/F Channel Attr 2")),
                        m("th[scope=col]", this.getText("LT00001012", "Samsung Channel")),
                        m("th[scope=col]", this.getText("LT00001079", "Created Date")),
                        m("th[scope=col]", this.getText("LT00000273", "Created By")),
                        m("th[scope=col]", this.getText("LT00000274", "Updated By")),
                        m("th[scope=col]", this.getText("LT00001080", "Updated Date")),
                        m("th[scope=col]", this.getText("LT00000092", "Action")),
                      )
                    ),
                    m("tbody",
                      searchResult?.length === 0 &&
                      m("tr",
                        { class: "align-middle" },
                        m("td",
                          { colspan: "100%" },
                          this.getText("EM00000141", "No records found.")
                        )
                      ),
                      searchResult?.length > 0 &&
                      searchResult.map((item) => {
                        return m("tr",
                          m("td", item.subsidiary),
                          m("td", item.customerCode),
                          m("td", item.mapType),
                          m("td", item.mapKey),
                          m("td.text-wrap", item.mapAttribute2),
                          m("td", item.mapAttribute1),
                          m("td", item.createdDate ? moment(item.createdDate).format(formats.LOCAL_TIME) : ""),
                          m("td", item.createdBy),
                          m("td", item.updatedBy),
                          m("td", item.updatedDate ? moment(item.updatedDate).format(formats.LOCAL_TIME) : ""),
                          m("td.center",
                            m('i.bi.bi-pencil-square.list-action-icon[title="Edit"]', {
                              onclick: () => { handleClickEdit(item) }
                            }),

                            m('i.bi.bi-trash-fill.list-action-icon[title="Delete"]', {
                              onclick: () => { handleClickDelete(item) }
                            }),
                          )
                        );
                      })
                    )
                  )
                ),
                searchResult?.length > 0 &&
                m(".px-3",
                  m(paginationComponent, {
                    currentPage: pagination.pageIndex,
                    pageSize: pagination.pageSize,
                    totalItems: pagination.totalItems,
                    data: searchResult,
                    onPageChanged: handlePageChanged,
                    onPageSizeChanged: handlePageSizeChanged,
                  })
                )
              )
            )
          )
        ),

        isAddSiteMappingOpen &&
        m(Dialog, {
          class: "modal-body-overflow-visible",
          closeOnOutsideClick: false,
          isOpen: isAddSiteMappingOpen,
          onClose: handleCloseAddNewSiteMappingModal,
          title: this.getText("LT00001083", "Insert"),
          content: m(".container",
            m(".card",
              m("form#form-add.card-body.needs-validation[novalidate]", { onsubmit: handleSubmitAddNew },
                m(".mt-2.position-relative",
                  m("label.form-label.mandatory[for='customers-add']",
                    this.getText("LT00008046", "Customer")
                  ),
                  m(SingleSelectComponent, {
                    id: "customers-add",
                    items: customers,
                    selectedItem: selectedCustomerAddNew,
                    onSelect: handleSelectCustomerAddNew,
                    required: true,
                  }),
                  m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
                ),

                m(".mt-2",
                  m("label.form-label[for='if-channel-attr-1-add']", this.getText("LT00001081", "I/F Channel Attr 1")),
                  m('input#if-channel-attr-1-add.form-control.form-control-bg[type="text"][maxLength="150"]', {
                    value: interfaceChannelAttr1AddNew,
                    onchange: handleChangeInterfaceChannelAttr1AddNew,
                  })
                ),

                m(".mt-2",
                  m("label.form-label[for='if-channel-attr-2-add']", this.getText("LT00001082", "I/F Channel Attr 2")),
                  m('input#if-channel-attr-2-add.form-control.form-control-bg[type="text"][maxLength="150"]', {
                    value: interfaceChannelAttr2AddNew,
                    onchange: handleChangeInterfaceChannelAttr2AddNew,
                  })
                ),
                m(".mt-2",
                  m("label.form-label[for='samsung-channel-add']", this.getText("LT00001012", "Samsung Channel")),
                  m('input#samsung-channel-add.form-control.form-control-bg[type="text"][maxLength="20"]', {
                    value: samsungChannelAddNew,
                    onchange: handleChangeSamsungChannelAddNew,
                  })
                ),
              )
            ),

            this.getBaseViews()
          ),
          footer: m("div.text-end",
            m("button.btn.btn-primary.me-2[form='form-add']", this.getText("LT00000022", "Save")),
            m("button.btn.btn-white",
              { onclick: handleCloseAddNewSiteMappingModal },
              this.getText('LT00000021', "Close")
            )
          )
        }),

        isEditSiteMappingOpen && tempEditItem &&
        m(Dialog, {
          class: "modal-body-overflow-visible",
          closeOnOutsideClick: false,
          isOpen: isEditSiteMappingOpen,
          onClose: handleCloseEditSiteMappingModal,
          title: this.getText("LT00000128", "Edit"),
          content: m(".container",
            m(".card",
              m(".card-body",
                m(".mt-2",
                  m("label.form-label.mandatory", this.getText("LT00008046", "Customer")),
                  m('input.form-control.form-control-bg[type="text"][disabled]', {
                    value: tempEditItem.customerCode,
                  })
                ),
                m(".mt-2",
                  m("label.form-label", this.getText("LT00001081", "I/F Channel Attr 1")),
                  m('input.form-control.form-control-bg[type="text"][disabled][maxLength="150"]', {
                    value: tempEditItem.mapKey,
                  })
                ),
                m(".mt-2",
                  m("label.form-label[for='if-channel-attr-2-edit']", this.getText("LT00001082", "I/F Channel Attr 2")),
                  m('input#if-channel-attr-2-edit.form-control.form-control-bg[type="text"][maxLength="150"]', {
                    value: editedInterfaceChannelAttr2,
                    onchange: handleChangeInterfaceChannelAttr2Edit,
                  })
                ),
                m(".mt-2",
                  m("label.form-label[for='samsung-channel-edit']", this.getText("LT00001012", "Samsung Channel")),
                  m('input#samsung-channel-edit.form-control.form-control-bg[type="text"][maxLength="20"]', {
                    value: editedSamsungChannel,
                    onchange: handleChangeSamsungChannelEdit,
                  })
                ),
              )
            ),

            this.getBaseViews()
          ),
          footer: m("div.text-end",
            m("button.btn.btn-primary.me-2",
              {
                onclick: handleClickSaveEdit,
              },
              this.getText("LT00000022", "Save")
            ),
            m("button.btn.btn-white",
              { onclick: handleCloseEditSiteMappingModal },
              this.getText("LT00000021", "Close")
            )
          )
        }),

        isExcelUploadModalOpen &&
        m(Dialog, {
          class: "modal-body-overflow-visible",
          closeOnOutsideClick: false,
          isOpen: isExcelUploadModalOpen,
          onClose: closeExcelUploadModal,
          title: this.getText("LT00001084", "Upload INTF Site Mapping"),
          content: m(".container",
            m("ol",
              m("li.fw-bold.mb-4",
                m(".mb-2", this.getText("LT00000218", "Download Template")),
                m("button.btn.btn-primary",
                  {
                    onclick: downloadTemplate,
                  },
                  m("i.bi.bi-file-earmark-arrow-down"),
                  this.getText("LT00000220", "Excel Template")
                )
              ),
              m("li.fw-bold.mb-4.list-unstyled",
                m("hr")
              ),
              m("li.fw-bold.mb-4",
                { value: 2 },
                m(".mb-2", this.getText("LT00000197", "Excel Upload")),
                m("form#upload-template-form.row.g-4.fw-normal.needs-validation[novalidate]",
                  { onsubmit: submitUploadTemplate },
                  m(".col-12.position-relative",
                    m(FileUploadInputComponent, {
                      accept: ".xlsx,.xls",
                      onInput: handleUploadInputChange,
                    }),
                  ),
                  m(".col-12",
                    m(".d-flex.justify-content-end.mb-3.gap-2",
                      m("button.btn.btn-primary[type=submit]",
                        { disabled: !fileInput },
                        this.getText("LT00000290", "Upload")
                      ),
                      m("button.btn.btn-white[type=button]",
                        { onclick: closeExcelUploadModal },
                        this.getText("LT00000021", "Close")
                      )
                    )
                  )
                )
              )
            ),
            this.getBaseViews()
          ),
        }),

        this.getBaseViews(),
      ];
    },
  };
}